import type { MouseEvent } from 'react';
import { Favorite } from '@mui/icons-material';

interface AdsListItemFavoriteButtonProps {
  favorite: boolean;
  onClick: (event: MouseEvent<SVGSVGElement>) => void;
}

export const AdsListItemFavoriteButton = ({
  favorite,
  onClick,
}: AdsListItemFavoriteButtonProps) => (
  <Favorite
    onClick={onClick}
    color='secondary'
    style={{
      fill: favorite ? '#1650FF' : 'none',
      stroke: favorite ? '#1650FF' : 'white',
      strokeWidth: 2,
    }}
  />
);
